<template>
  <div style="display: flex;
justify-content: center;
align-items: center;
height: 100vh;">
    <vs-card style="
        min-width: 350px;
        max-width: 400px;
        border-radius: 10px;
     
      ">
      <div>
        <div class="p-2">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <img src="https://www.ausa.com.mx/img/Ausa-logov5.PNG" alt="logo"
                  style="margin: auto;max-width: 200px!important;" />
              </div>
              <div class="col-md-12" style="top: 30px">
                <h4 class="login-title-text" style="text-align: center">
                  Inicio de Sesión
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="p-2">
          <form @submit.prevent="loginSuccess()" class="form-horizontal m-t-20" autocomplete="off">
            <div class="container">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <div class="form-group row mr-1">
                    <vs-input style="width: 300px" :danger="errors.has('username')" :danger-text="errors.has('username') ? errors.first('username') : ''
                      " name="username" data-vv-as="usuario" v-validate="'required|max:16'" type="text"
                      label-placeholder="Usuario" v-model.trim="user.username" />
                  </div>
                </div>
                <br />
                <div class="col-md-6 col-sm-12" style="left: 4px">
                  <div class="form-group row">
                    <vs-input style="width: 300px" :danger="errors.has('password')" :danger-text="errors.has('password') ? errors.first('password') : ''
                      " name="password" :type="hasVisiblePassword == false ? 'password' : 'text'"
                      data-vv-as="contraseña" v-validate="'required'" label-placeholder="Contraseña" autocomplete
                      v-model.trim="user.password" icon-after="true" :icon="hasVisiblePassword == false
                        ? 'visibility'
                        : 'visibility_off'
                        " v-on:icon-click="hasVisiblePassword = !hasVisiblePassword">
                    </vs-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-md-12" style="top: 30px">
                  <router-link class="password-recovery-title-text" style="text-align: left"
                    :to="{ name: 'PasswordRecovery' }">¿Olvidaste tu contraseña?</router-link>
                </div>
              </div>
            </div>

            <div class="form-group text-center row m-t-20">
              <div class="col-12">
                <br />
                <button v-if="!loggedIn" class="vs-button-primary vs-button-filled btn-block vs-button" :disabled="user.username && user.password && !loggedIn ? false : true
                  ">
                  <span>Iniciar Sesión</span>
                </button>
                <button v-else class="vs-button-primary vs-button-filled btn-block vs-button" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Procesando...
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div slot="footer" style="margin-top: -30px">
        <!--<vs-row vs-justify="center">
            <p style="text-align:center; margin-bottom: 50px;" class="text-muted">Login hecho para el ambiente de desarrollo local. <br/>Si usted esta viendo este login comuniquese a <b>desarrollo@ausa.com.mx</b></p>
        </vs-row>-->
        <br />
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginService from "@/services/login/login.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  title() {
    return this.$route.meta.title
  },
  data() {
    return {
      loggedIn: false,
      hasVisiblePassword: false,
      user: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState(["domain", "informationPage"]),
  },
  methods: {
    setMacCookie(MacAdress) {
      var expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 3);
      document.cookie =
        "Mac=" + MacAdress + ";expires=" + expiryDate + "; path=/";
    },

    setSessionTime() {
      var expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 3);
      document.cookie =
        "SessionTime=Active" + ";expires=" + expiryDate + "; path=/";
    },

    setUsloginCookie(uslogin, parameter) {
      var expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 3);
      document.cookie = uslogin.toString() + "=" + parameter + "; path=/";
    },

    async loginSuccess() {
      this.loggedIn = true;

      let valid = await this.$validator.validateAll();
      this.user.username = this.user.username.toLocaleLowerCase();

      if (valid) {
        let loginResponse = await LoginService.verifyLogin(this.user);
        if (loginResponse["success"] == true) {
          // await this.verfiyMacAdress();
          // await MetodosGenerales.guardarEnSesionInfoReporte(permisos, 'permisos');
          ManagerLocalStorage.addSingleLocalStorage(
            this.user.username,
            this.informationPage.nameLocalStoragePGV2
          );
          window.sessionStorage.setItem(
            "CambioContraseña",
            loginResponse["CambioContraseña"]
          );
          window.sessionStorage.removeItem("passwordWarned");
          await this.setMacCookie(loginResponse["macAdress"]);
          await this.setUsloginCookie(
            'name',//this.user.username,
            ',' + loginResponse["nombreEncriptado"]);

          await this.setSessionTime();
          window.location.href = this.domain.domainNameWithHttp;
        } else {
          if (loginResponse["redirect"] != null) {
            //TODO REDIRECCIONAR AQUI A LA VISTA QUE TRAE Redirect
            this.$router.push({
              name: loginResponse["redirect"],
              params: {
                bloqueoMsg: loginResponse["msg"],
                bloqueoData: loginResponse["data"],
                numeroInfo: loginResponse["numeroInfo"],
                correoInfo: loginResponse["correoInfo"],
                uslogin: this.user.username,
              },
            });
          } else {
            this.$vs.notify({
              title: "Error al iniciar sesión",
              text: loginResponse["msg"],
              color: "danger",
              icon: "cancel",
              position: "bottom-center",
              time: 15000,
            });
            this.loggedIn = false;
            this.user.password = "";
          }
        }
        try {
        } catch (error) {
          this.$vs.notify({
            title: "Hubo un problema al iniciar sesión",
            text: "Contactar al área de desarrollo.",
            color: "danger",
            icon: "cancel",
            position: "bottom-center",
            time: 15000,
          });
          this.loggedIn = false;
          this.user.password = "";
        }
      }
    },
    async verfiyMacAdress() {
      if (this.readCookie("Mac") == null) {
        var response = await LoginService.enviarCorreoNuevoDispositivo();
      } else {
      }
    },
    readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },

  },
  mounted() {
    LoginService.serviceWorkerStart();
    ManagerLocalStorage.removeLocalStorage(
      this.informationPage.nameLocalStoragePGV2
    );
    MetodosGenerales.eliminaCookie(this.informationPage.nameCookiePGV2);
  },
};
</script>

<style scoped>
.login-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 0px;
  color: #757575 !important;
}

.password-recovery-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
  color: #0288d1 !important;
}
</style>
